import { useEffect, useState } from "react";
import styles from "./LeftSidebar.module.css";
import { ReactComponent as DashboardIcon } from "../../assets/images/Dashboard3.svg";
import { ReactComponent as UserDashboardIcon } from "../../assets/images/Report1.svg";
import { ReactComponent as UserIcon } from "../../assets/images/User.svg";
import { ReactComponent as ReportIcon } from "../../assets/images/Report2.svg";
import { ReactComponent as SettingIcon } from "../../assets/images/Setting2.svg";
import { ReactComponent as OrgIcon } from "../../assets/images/Org2.svg";
// import VFLogo from "../../assets/images/VFLogo02.png";
import VFLogo from "../../assets/images/Visualise_Icon_Teal.png";
import ProfilePic from "../../assets/images/ProfilePic1.svg";
import { Link, useLocation } from "react-router-dom";
import {
  CLIENT_ADMIN_ROLE_ID,
  USER_ROLE_ID,
  VF_ADMIN_ROLE_ID,
} from "../../constants/constant";
import { useSelector } from "react-redux";
import CustomTooltip from "../tooltip/CustomTooltip";

const LeftSidebar = () => {
  const location = useLocation();
  const pathName = location?.pathname?.replace(/\//g, "");
  const [activeItem, setActiveItem] = useState(pathName);

  const profileImage = useSelector(
    (state) => state?.user?.currentUser?.data?.profileImage
  );
  const userRole = useSelector((state) => state?.user?.userRoleId);
  const searchParams = localStorage.getItem("searchParams");

  console.log("location>>>>", location, pathName);

  const handleItemClick = (itemName) => {
    if (pathName === "expense-target") return;
    setActiveItem(itemName);
  };

  useEffect(() => {
    setActiveItem(pathName);
  }, [pathName]);

  return (
    <div className={styles.rectangleGroup}>
      {/* <b className={styles.vf}>VF</b> */}
      <div style={{ marginBottom: "30px" }}>
        <Link to="/home">
        <CustomTooltip title={"Go to Visualise"}>
        <img className={styles.vfLogo02} alt="" src={VFLogo} />
        </CustomTooltip>
        </Link>
      </div>

      {(userRole?.includes(USER_ROLE_ID) ||
        userRole?.includes(CLIENT_ADMIN_ROLE_ID)) &&
        searchParams === "/" && (
          <div
            className={`${styles.categoryParent} ${
              activeItem === "dashboard" || activeItem.includes("reports")
                ? styles.active
                : ""
            }`}
          >
            <Link to="/dashboard" onClick={() => handleItemClick("dashboard")}>
              <CustomTooltip title={"Dashboard"}>
                <UserDashboardIcon />
                {/* <div className={styles.dashboard}>Dashboard</div> */}
              </CustomTooltip>
            </Link>
          </div>
        )}

      {(userRole?.includes(VF_ADMIN_ROLE_ID) ||
        userRole?.includes(CLIENT_ADMIN_ROLE_ID)) &&
        searchParams === "/admin" && (
          <div
            className={`${styles.categoryParent} ${
              activeItem === "dashboard" ? styles.active : ""
            }`}
          >
            <Link to="/dashboard" onClick={() => handleItemClick("dashboard")}>
              <CustomTooltip title={"Dashboard"}>
                <DashboardIcon />
                {/* <div className={styles.dashboard}>Dashboard</div> */}
              </CustomTooltip>
            </Link>
          </div>
        )}

      {(userRole?.includes(CLIENT_ADMIN_ROLE_ID) ||
        userRole?.includes(VF_ADMIN_ROLE_ID)) &&
        searchParams === "/admin" && (
          <div
            className={`${styles.categoryParent} ${
              activeItem === "users" ? styles.active : ""
            }`}
          >
            <Link to="/users" onClick={() => handleItemClick("users")}>
              <CustomTooltip title={"Users"}>
                <UserIcon />
              </CustomTooltip>
            </Link>
          </div>
        )}

      {userRole?.includes(VF_ADMIN_ROLE_ID) && searchParams === "/admin" && (
        <div
          className={`${styles.categoryParent} ${
            activeItem === "organisations" ? styles.active : ""
          }`}
        >
          <Link
            to="/organisations"
            onClick={() => handleItemClick("organisations")}
          >
            <CustomTooltip title={"Organisations"}>
              <OrgIcon />
            </CustomTooltip>
          </Link>
        </div>
      )}

      {userRole?.includes(VF_ADMIN_ROLE_ID) && searchParams === "/admin" && (
        <div
          className={`${styles.categoryParent} ${
            activeItem === "reports" ? styles.active : ""
          }`}
        >
          <Link to="/reports" onClick={() => handleItemClick("reports")}>
            <CustomTooltip title={"Reports"}>
              <ReportIcon />
              {/* <div className={styles.dashboard}>Reports</div> */}
            </CustomTooltip>
          </Link>
        </div>
      )}

      {(userRole?.includes(CLIENT_ADMIN_ROLE_ID) ||
        userRole?.includes(VF_ADMIN_ROLE_ID)) &&
        searchParams === "/admin" && (
          <div
            className={`${styles.categoryParent} ${
              activeItem === "settings" ? styles.active : ""
            }`}
          >
            <Link to="/settings" onClick={() => handleItemClick("settings")}>
              <CustomTooltip title={"Settings"}>
                <SettingIcon />
                {/* <div className={styles.dashboard}>Settings</div> */}
              </CustomTooltip>
            </Link>
          </div>
        )}

      {(userRole?.includes(CLIENT_ADMIN_ROLE_ID) ||
        userRole?.includes(USER_ROLE_ID) ||
        userRole?.includes(VF_ADMIN_ROLE_ID)) && (
        <div
          className={`${styles.categoryParent} ${
            activeItem === "my-account" ? styles.active : ""
          } ${styles.myAccountParent}`}
        >
          <Link to="/my-account" onClick={() => handleItemClick("my-account")}>
            <CustomTooltip title={"My Account"}>
              <img
                className={styles.groupInner}
                alt=""
                src={profileImage ? profileImage : ProfilePic}
              />
              {/* <div className={styles.myAccount}>My Account</div> */}
            </CustomTooltip>
          </Link>
        </div>
      )}
    </div>
  );
};

export default LeftSidebar;
